import { ModuleDisplayTypeEnum } from "@resource/common";
import {
  Assessment,
  Feedback,
  HeaderGreeting,
  InfoCards,
  InfoChips,
  InterviewScheduler,
  InterviewTeam,
  Links,
  Location,
  Media,
  Mission,
  Offer,
  RichText,
  Schedule,
  Time,
} from "components/legacy/modules";

import PreviewInterviewScheduler from "../PreviewInterviewScheduler";

interface ModuleContainerProps {
  id: string;
  displayType: string;
  stageId: string;
  guideId: string;
  isPreview?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any;
  refetch?(): void;
}

function ModuleContainer({
  id,
  displayType,
  guideId,
  stageId,
  data,
  refetch,
  isPreview = false,
}: ModuleContainerProps) {
  let moduleContent;
  if (data.disabled) {
    return null;
  }

  switch (displayType) {
    case ModuleDisplayTypeEnum.InfoChips:
      moduleContent = <InfoChips key={id} {...data} />;
      break;

    case ModuleDisplayTypeEnum.InfoCards:
      moduleContent = <InfoCards key={id} {...data} />;
      break;

    case ModuleDisplayTypeEnum.Mission:
      moduleContent = <Mission key={id} {...data} />;
      break;

    case ModuleDisplayTypeEnum.GreetingHeader:
      moduleContent = <HeaderGreeting key={id} {...data} />;
      break;

    case ModuleDisplayTypeEnum.Time:
      moduleContent = <Time key={id} guideId={guideId} {...data} />;
      break;

    case ModuleDisplayTypeEnum.Location:
      moduleContent = <Location key={id} {...data} />;
      break;

    case ModuleDisplayTypeEnum.Schedule:
      moduleContent = <Schedule stageId={stageId} key={id} {...data} />;
      break;

    case ModuleDisplayTypeEnum.Links:
      moduleContent = <Links key={id} {...data} />;
      break;
    case ModuleDisplayTypeEnum.InterviewTeam:
      moduleContent = <InterviewTeam key={id} {...data} />;
      break;

    case ModuleDisplayTypeEnum.TeamPhoto:
      moduleContent = (
        <Media
          key={id}
          {...{
            ...data,
            mediaLink: data.photoUrl,
          }}
        />
      );
      break;

    case ModuleDisplayTypeEnum.Media:
      moduleContent = <Media key={id} {...data} />;
      break;

    case ModuleDisplayTypeEnum.CandidatePostInterviewFeedback:
      moduleContent = <Feedback key={id} stageId={stageId} {...data} />;
      break;

    case ModuleDisplayTypeEnum.InterviewScheduler:
      if (isPreview) {
        moduleContent = <PreviewInterviewScheduler key={id} {...data} />;
      } else {
        moduleContent = (
          <InterviewScheduler
            key={id}
            refetch={refetch}
            stageId={stageId}
            {...data}
          />
        );
      }
      break;
    case ModuleDisplayTypeEnum.RichText:
      moduleContent = <RichText key={id} {...data} />;
      break;
    case ModuleDisplayTypeEnum.Assessment:
      moduleContent = <Assessment key={id} {...data} />;
      break;
    case ModuleDisplayTypeEnum.Offer:
      moduleContent = <Offer key={id} {...data} />;
      break;

    default:
      moduleContent = <div />;
      break;
  }

  return moduleContent;
}

export default ModuleContainer;
